(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1145],{

/***/ 7340:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Example; }
});

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/views/Marketing/Blog/components/BlogPage/index.tsx
var BlogPage = __webpack_require__(32526);
// EXTERNAL MODULE: ./src/views/Marketing/components/Footer/index.tsx
var Footer = __webpack_require__(45867);
// EXTERNAL MODULE: ./src/views/Marketing/components/NavBar/index.tsx
var NavBar = __webpack_require__(82969);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/ScrollView/index.js
var ScrollView = __webpack_require__(38174);
var ScrollView_default = /*#__PURE__*/__webpack_require__.n(ScrollView);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/StyleSheet/index.js
var StyleSheet = __webpack_require__(84099);
var StyleSheet_default = /*#__PURE__*/__webpack_require__.n(StyleSheet);
// EXTERNAL MODULE: ./src/constants/index.ts + 6 modules
var constants = __webpack_require__(22120);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/views/Marketing/Blog/marketing/mercari-photography-tips/index.tsx









function Page() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)((ScrollView_default()), {
    style: styles.scrollView,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(NavBar/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(BlogPage/* default */.Z, {
      author: "OneShop Team",
      dateTime: "2022-09-13",
      tag: "Mercari",
      title: "5 Simple Yet Effective Tips To Take Good Photos for Your Mercari Listings",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Anyone active on social media knows what attracts people to posts: appealing photos and stand-out graphics. This is the reason why some tend to edit their photos before posting - so they can earn more \"likes,\" comments, and reactions from other users."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "A similar strategy applies to selling on online marketplaces like Mercari. Buyers don't simply look for the items they need. They are first drawn to listings that have clear, beautiful images. Sometimes it doesn't matter if your item is branded or a rare find if its photo is blurry or low-quality. Buyers tend to scroll past this kind of listing. How do you avoid this? How do you draw in potential customers to your items?"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Why take great photos?"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "It is important to have attractive images to pull in customers. But why does it matter?"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
              children: "Additional exposure"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: "Aside from gaining more \"views\" on your listings, you get additional exposure to other Mercari users. The more \"likes\" you get, the more other users flock to your listing. They will get curious about why a lot of people \"liked\" your item. Naturally, they will click on it as well. If they are interested, they will \"like\" and save it to their wishlist."
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
              children: "Help buyers decide"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: "Having great photos also helps customers decide to purchase. For instance, buyers would want to see the bag's details if you are selling a Charles & Keith quilted clutch. They want to see the texture of the material and the brand logo stitched on the bag (for authenticity) They are also interested in details on the strap and the pockets inside the bag."
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: "Taking one to two photos of the items is not enough. Buyers prefer to see close-ups of the item. Otherwise, they may get disappointed if it turns out to be far from their expectations."
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: "For example, you are selling a pair of Nike shoes. However, you didn't indicate its exact model nor did you take a photo from all sides. A customer who isn't familiar with the details may purchase it expecting a thick yet soft foam but instead gets a hard, rubbery material instead. Naturally, they would be disappointed and may request a return from you. Imagine the inconvenience of both parties trying to meet expectations."
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
              children: "Demonstrate transparency"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: "Mercari is a marketplace to sell pre-loved items or even new ones that have never been used. As some of these have been used, they may carry minor flaws with them: t-shirts with faded printed designs, bags with tiny scratches, or shoes with stained shoelaces."
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: "Some sellers don't bother repairing the item before selling. This is understandable if you can't find a good repair shop. This is why you should always include a close-up of the item's flaws. By doing this, you are showing potential buyers the condition of the item. Again, you are helping them decide whether or not to purchase."
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: "Additionally, you are telling Mercari users that you are a credible or trustworthy seller. You are unafraid to show honesty regarding your items' conditions. This is considered \"plus points\" to the buyer and not a turn-off."
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Five tips for taking attractive images"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "What you should know first is you don't need a professional camera. You can always use your smartphone like an iPhone or an Android to take pictures of your items. However, there are effective ways to make your photos better-looking."
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ol", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
              children: "Have good lighting"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: "Ideally, you should take photos under natural light. This means opening the curtains in your home and letting the sun rays stream in. The sun's light gives a better view of your items' details."
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: "If you can't get natural light in your home, you can always use artificial light. Just make sure there are little to no shadows obscuring the view of the items. When possible, direct the light to the items."
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
              children: "Set up a flat lay"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: "For items such as bags, scarves, watches, and other similar accessories, place them flat against a solid surface and background. Flat lay is a photography style where the products are placed on a vertical surface, generally arranged with props."
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: "Doing so places the sole focus on the items. Otherwise, if you take photos against a messy background (e.g., the pillows on your bed or the kitchen seen from afar), then buyers will be distracted by the background rather than what you are selling. A cluttered background is a turn-off for customers."
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
              children: "Hang up clothes"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: "Most clothing isbetter viewed when it ishung up. Buyers can imagine how the clothes would look when they wear them. They can better see the fabric or material and assess if it needs ironing or not. Furthermore, they can estimate the length of their bodies, especially if you hang them on a mannequin."
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
              children: "Take photos from different angles."
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: "Buyers prefer seeing details of items before purchasing them. This is why you should take pictures from different sides. For example, if you are selling Uniqlo wide-legged pants, show the front, back, and close-ups of the zipper, crotch area, and material."
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: "Another example is selling a Celine shoulder bag. Take pictures of the front, back, side-views, the inside, and angles where the pockets are visible. If there is a removable strap, take photos with it attached and one without. This helps buyers view how the overall style looks."
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
              children: "Do minimal edits"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: "Sometimes, it is inevitable that your photos don't look as good as your setup. This is perfectly fine - you can always edit them using an app or a website. When editing, the crucial aspects to consider are:"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: "Brightness"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: "Contrast (darkness of the shadows in the photo)"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: "Clarity or crisp quality (avoid blurring)"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: "Saturation (intensity of color)"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: "If you are unfamiliar with these terms, you can explore them yourself using a photo-editing app. You can increase or decrease each setting and find out which one looks good for your image."
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: "Keep in mind not to make drastic changes. Otherwise, your photo may look discolored or generally badly edited. In turn, buyers will scroll past your listing. Heavily-edited images are turn-offs for people. If you are uncertain about the edit you did, ask friends to check them for you."
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Manage your business efficiently"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Selling online takes effort and time, no matter how long you have been doing this. This is why taking advantage of service apps like OneShop comes in handy."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "OneShop has cross-listing features that cross-post your listings to other marketplaces. These include Poshmark, Mercari, Depop, and eBay. When you cross-list, thousands of other users get to see your items, thereby increasing your chances of closing a sale."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "With the in app camera, you can do photo editing. You can choose between removing the background from the image and retaining its original look. \"Object Cutout\" means the item has a plain white background. Some marketplaces require this so buyers can focus on the items themselves. The cutout also gives the photos an overall clean look."
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["OneShop is greatly helpful for sellers. It has other features like delisting, scheduled listings, smart listing prices, and others that make navigating your business much easier. Take advantage of its", ' ', /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
          href: "https://tools.oneshop.com/signup",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: constants/* Marketing.TrialDuration */.F1.TrialDuration
          }), "-day free trial"]
        }), ' ', "today. You can experience the convenience OneShop provides to help you close more sales faster."]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {})]
  });
}
var styles = StyleSheet_default().create({
  scrollView: {
    flex: 1
  }
});
;// CONCATENATED MODULE: ./src/pages/blog/mercari-photography-tips.tsx





function Example() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: "5 Simple Yet Effective Tips To Take Good Photos for Your Mercari Listings"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "description",
        content: "Want to catch the attention of more buyers? Take clear, good photos of your items\u2013here are the proper ways to do it."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "canonical",
        href: "https://tools.oneshop.com/blog/mercari-photography-tips"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:url",
        content: "https://tools.oneshop.com/blog/mercari-photography-tips"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:title",
        content: "5 Simple Yet Effective Tips To Take Good Photos for Your Mercari Listings"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:description",
        content: "Want to catch the attention of more buyers? Take clear, good photos of your items\u2013here are the proper ways to do it."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:image",
        content: "https://tools.oneshop.com/static/images/og-image.png?v=3"
      }, 'og-image'), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:published_time",
        content: "2022-09-13T00:00:00-00:00"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:modified_time",
        content: "2022-09-13T00:00:00-00:00"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:tag",
        content: "Mercari"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:publisher",
        content: "https://www.facebook.com/oneshopcompany"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Page, {})]
  });
}

/***/ }),

/***/ 23254:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/mercari-photography-tips",
      function () {
        return __webpack_require__(7340);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2678,4885,8409,8908,8776,8174,6770,1664,4965,9561,5675,1577,6554,858,275,9774,2888,179], function() { return __webpack_exec__(23254); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);